import { useEffect, useState } from "react";
import api from "@/lib/api";

const META = {
  privacy: { title: "Privacy Policy", key: "privacy" },
  terms: { title: "Terms & Conditions", key: "terms" },
  cancellation: { title: "Cancellation Policy", key: "cancellation_policy" },
};

export default function Policy({ kind }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const meta = META[kind];
  const text = settings ? settings[meta.key] : "Loading…";

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-xs uppercase tracking-[0.2em] text-[#B87333] font-semibold">Legal</p>
      <h1 className="mt-3 font-serif text-4xl text-[#2C2621] font-semibold" data-testid="policy-title">{meta.title}</h1>
      <div className="mt-8 bg-white rounded-2xl border border-[#E6DEC3] p-8 shadow-[0_4px_20px_rgba(44,38,33,0.04)]">
        <p className="text-[#635B52] leading-relaxed whitespace-pre-line" data-testid="policy-body">{text}</p>
      </div>
      <p className="mt-6 text-sm text-[#635B52]">Questions? Email masayahospitality@gmail.com.</p>
    </div>
  );
}
